/**
 * Main nav: mega menu — hover (desktop) + click (touch/mouse) + keyboard.
 */
document.addEventListener('DOMContentLoaded', () => {
	const items = document.querySelectorAll('.main-nav__item[data-has-submenu]');

	const closeAll = (except) => {
		items.forEach((i) => {
			if (i !== except) {
				i.classList.remove('is-open');
				const trig = i.querySelector('.main-nav__link--has-submenu');
				if (trig) trig.setAttribute('aria-expanded', 'false');
			}
		});
	};

	items.forEach((item) => {
		let closeTimer = null;
		const trigger  = item.querySelector('.main-nav__link--has-submenu');
		const menu     = item.querySelector('.mega-menu');

		const open = () => {
			clearTimeout(closeTimer);
			closeAll(item);
			item.classList.add('is-open');
			if (trigger) trigger.setAttribute('aria-expanded', 'true');
		};

		const close = (delay = 120) => {
			closeTimer = setTimeout(() => {
				item.classList.remove('is-open');
				if (trigger) trigger.setAttribute('aria-expanded', 'false');
			}, delay);
		};

		// Hover (desktop with mouse).
		item.addEventListener('mouseenter', open);
		item.addEventListener('mouseleave', () => close());

		if (menu) {
			menu.addEventListener('mouseenter', () => clearTimeout(closeTimer));
			menu.addEventListener('mouseleave', () => close());
		}

		// Click — toggle open/close. Works for touch + click on chevron.
		if (trigger) {
			trigger.addEventListener('click', (e) => {
				e.preventDefault();
				e.stopPropagation();
				clearTimeout(closeTimer);
				if (item.classList.contains('is-open')) {
					item.classList.remove('is-open');
					trigger.setAttribute('aria-expanded', 'false');
				} else {
					open();
				}
			});

			// Keyboard: Enter / Space / ArrowDown.
			trigger.addEventListener('keydown', (e) => {
				if (e.key === 'Enter' || e.key === ' ' || e.key === 'ArrowDown') {
					e.preventDefault();
					open();
					// Focus first link in mega-menu.
					const firstLink = menu && menu.querySelector('.mega-menu__link');
					if (firstLink) firstLink.focus();
				}
			});
		}
	});

	// Outside click — close all.
	document.addEventListener('click', (e) => {
		if (!e.target.closest('.main-nav__item[data-has-submenu]')) {
			closeAll(null);
		}
	});

	// ESC — close all.
	document.addEventListener('keydown', (e) => {
		if (e.key === 'Escape') closeAll(null);
	});
});
